import store from '~/store'

export function userCheckAccess({abilities, checkUserType}) {
  const userType = store.getters['user/userType']
  const userRoleAbilities = store.getters['user/userRoleAbilities']
  const includesAll = (arr, values) => values.every((v) => arr.includes(v))
  const onCheckAbilities =
    userRoleAbilities &&
    (Array.isArray(abilities)
      ? includesAll(userRoleAbilities, abilities)
      : userRoleAbilities.includes(abilities))
  let result = false
  if (userType === 'superadmin') {
    result = true
  } else {
    if (abilities && checkUserType) {
      result = checkUserType === userType && onCheckAbilities
    } else if (abilities && !checkUserType) {
      result = onCheckAbilities
    } else if (!abilities && checkUserType) {
      result = checkUserType === userType
    }
  }
  return result
}
